import { post } from "venuescanner-js/services/api";
const inFlight = {};
export const Geo = {
  locationFromIp: async () => {
    return post("/find-me", {}, { returnData: false });
  },

  locationFromLatLng: async ({ lat, lng }) => {
    const id = `${lat},${lng}`;
    if (inFlight[id]) {
      const reply = new Promise((resolve) => {
        inFlight[id].push(resolve);
      });
      return reply;
    } else {
      inFlight[id] = [];
    }
    const data = await post(
      "/find-lat-lng",
      { lat, lng },
      { returnData: false }
    );

    while (inFlight[id].length) {
      inFlight[id].shift()(data);
    }
    delete inFlight[id];
    return data;
  },
};
